import DataUtility from "@/services/DataUtility";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface PerawatState {
  listPerawat: Perawat[];
}

interface Perawat {
  id: number;
  nama: string;
}

@Module({ store, dynamic: true, name: "storePerawat" })
class PerawatStore extends VuexModule implements PerawatState {
  listPerawat: Perawat[] = [];
  listKaryawan = [];

  @Mutation SET_LIST_PERAWAT_COMBO(listPerawat: Perawat[]) {
    this.listPerawat = listPerawat;
  }

  @Mutation SET_LIST_KARYAWAN_COMBO(listKaryawan: []) {
    this.listKaryawan = listKaryawan;
  }


  @Action actListPerawatall() {
    const dt = DataUtility.getListPerawat();
    dt.then(dt => {
      const listPerawat = dt.data;
      this.SET_LIST_PERAWAT_COMBO(listPerawat);
    });
  }
  
  @Action actListKaryawanAll() {
    const dt = DataUtility.getListKaryawan();
    dt.then(dt => {
      const listKaryawan = dt.data;
      this.SET_LIST_KARYAWAN_COMBO(listKaryawan);
    });
  }
}

export const storePerawat = getModule(PerawatStore);
